import * as React from "react";
import CurrencyInputField from "react-currency-input-field";
import { cn } from "@/lib/utils";

interface CurrencyInputProps {
  value?: number;
  onValueChange?: (value: number | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ className, value, onValueChange, placeholder = "0,00", disabled, ...props }, ref) => {
    return (
      <CurrencyInputField
        id="currency-input"
        name="currency-input"
        placeholder={placeholder}
        defaultValue={value}
        decimalsLimit={2}
        decimalSeparator=","
        groupSeparator="."
        prefix="R$ "
        onValueChange={(value) => {
          const numericValue = value ? parseFloat(value) : undefined;
          onValueChange?.(numericValue);
        }}
        disabled={disabled}
        className={cn(
          "flex h-10 w-full rounded-md border-[0.5px] border-input bg-input-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
CurrencyInput.displayName = "CurrencyInput";

export { CurrencyInput };
